module.exports = __webpack_public_path__ + "static/media/quote4.8be1ebe3.png";